import { Injectable, NgModuleFactory, Type } from '@angular/core';

import { ModuleListService } from '@modweb5/sharedServices/moduleList/moduleList.service';
import { TModuleInfo } from '@modweb5/interfaces/modules.interface';
import {ELazyModules} from '@modweb5/sharedEnums/lazyModules.enum';


@Injectable({
	providedIn: 'root'
})
export class ConfigModuleList {

	constructor(
		private moduleListService: ModuleListService
	) {
	}

	// ----------------------------------------------------------------------------------------------
	init(): void {


		let moduleListMap: Map<string, TModuleInfo> = new Map();

		let order = 1;

		moduleListMap.set('appVersions', { 
			moduleId: 'appVersions',
			moduleLabels: { 'cs': 'Verze programů'},
			navigateButtonName: 'appversions.png',
			moduleIconName: 'appversions.ico',
			submodules: [],
			order: order,
			applyAccessRights: true
		});

		order++;
		moduleListMap.set('customers', { 
			moduleId: 'customers',
			moduleLabels: { 'cs': 'Uživatelé programů'},
			navigateButtonName: 'promoter.png',
			moduleIconName: 'promoter.ico',
			submodules: ['customerApps'],
			order: order,
			applyAccessRights: true
		});

		order++;
		moduleListMap.set('customerApps', { 
			moduleId: 'customerApps',
			moduleLabels: { "cs": "Používané programy", "en": "Used programs" },
			navigateButtonName: 'uzivatele.png',
			moduleIconName: 'uzivatele.ico',
			submodules: [],
			order: -1,
			applyAccessRights: true
		});

		order++;
		moduleListMap.set('users', { 
			moduleId: 'users',
			moduleLabels: { "cs": "Uživatelé", "en": "Users" },
			navigateButtonName: 'uzivatele.png',
			moduleIconName: 'uzivatele.ico',
			submodules: [],
			order: order,
			applyAccessRights: true
		});

		order++;
		moduleListMap.set('accessRights', { 
			moduleId: 'accessRights',
			moduleLabels: { "cs": "Skupiny přístupových práv", "en": "Access rights groups" },
			navigateButtonName: 'accessrights.png',
			moduleIconName: 'accessrights.ico',
			submodules: ['accessRightValues'],
			order: order,
			applyAccessRights: true
		});

		moduleListMap.set('accessRightValues', {
			moduleId: 'accessRightValues',
			moduleLabels: { "cs": "Přístupová práva skupin", "en": "Group Access Rights" },
			navigateButtonName: 'help1.png',
			moduleIconName: 'help.ico',
			submodules: [],
			order: -1,
			applyAccessRights: true
		});


		order++;
		moduleListMap.set('history', { 
			moduleId: 'history',
			moduleLabels: { "cs": "Historie", "en": "History" },
			navigateButtonName: 'historie.png',
			moduleIconName: 'historie.ico',
			submodules: [],
			order: order,
			applyAccessRights: true
		});

		order++;
		moduleListMap.set('help', { 
			moduleId: 'help',
			moduleLabels: { "cs": "Nápověda", "en": "Help" },
			navigateButtonName: 'help1.png',
			moduleIconName: 'help.ico',
			submodules: [],
			order: order,
			applyAccessRights: false
		});

		this.moduleListService.setModuleListMap(moduleListMap);
		this.init2();
	}

// ----------------------------------------------------------------------------------------------
	init2(): void {

		const cLazyLoadedModules = {
			[ELazyModules.MODULE_MAIN_APP]: {
				loadModule: async () => (await import('@modweb5/lazyLoadedModules/moduleMainApp/moduleMainApp.module')).ModuleMainApp as NgModuleFactory<any> | Type<any>
			},
			[ELazyModules.MODULE_APP_VERSIONS]: {
				loadModule: async () => (await import('@modweb5/orax/modules/lazyLoaded/moduleAppVersions/moduleAppVersions.module')).ModuleAppVersions as NgModuleFactory<any> | Type<any>
			},
			[ELazyModules.MODULE_CUSTOMERS]: {
				loadModule: async () => (await import('@modweb5/orax/modules/lazyLoaded/moduleCustomers/moduleCustomers.module')).ModuleCustomers as NgModuleFactory<any> | Type<any>
			},
			[ELazyModules.MODULE_CUSTOMER_APPS]: {
				loadModule: async () => (await import('@modweb5/orax/modules/lazyLoaded/moduleCustomerApps/moduleCustomerApps.module')).ModuleCustomerApps as NgModuleFactory<any> | Type<any>
			},
			[ELazyModules.MODULE_USERS]: {
				loadModule: async () => (await import('@modweb5/lazyLoadedModules/moduleUsers/moduleUsers.module')).ModuleUsers as NgModuleFactory<any> | Type<any>
			},
			[ELazyModules.MODULE_ACCESS_RIGHTS]: {
				loadModule: async () => (await import('@modweb5/lazyLoadedModules/moduleAccessRights/moduleAccessRights.module')).ModuleAccessRights as NgModuleFactory<any> | Type<any>
			},
			[ELazyModules.MODULE_ACCESS_RIGHT_VALUES]: {
				loadModule: async () => (await import('@modweb5/lazyLoadedModules/moduleAccessRightValues/moduleAccessRightValues.module')).ModuleAccessRightValues as NgModuleFactory<any> | Type<any>
			},
			[ELazyModules.MODULE_HISTORY]: {
				loadModule: async () => (await import('@modweb5/lazyLoadedModules/moduleHistory/moduleHistory.module')).ModuleHistory as NgModuleFactory<any> | Type<any>
			},
		};
		this.moduleListService.setListOfImportedModules(cLazyLoadedModules);

	}

}
